export const FAIL_FINISH_PROJECT =
  'Algo inesperado aconteceu ao finalizar o projeto'

export const FAIL_DELETE_CLIENT =
  'Algo inesperado aconteceu ao excluir o cliente'

export const TRY_AGAIN_LATER = 'Tente novamente mais tarde.'
